import _ from 'lodash';
import { Box } from '@material-ui/core';
import { i18n } from '@lingui/core';
import { t, Trans } from '@lingui/macro';
import FormSection from '../../form/FormSection';
import { NgpLabelValue } from '../../form/NgpLabelValue';
import {
    AGENT_ASN_FIELD,
    AGENT_GEO_ISP_CITY_FIELD,
    AGENT_GEO_ISP_COUNTRY_FIELD,
    AGENT_GEO_ISP_ISO_CODE_FIELD,
    AGENT_GEO_ISP_LATITUDE_FIELD,
    AGENT_GEO_ISP_LONGITUDE_FIELD,
    AGENT_GEO_ISP_POSTAL_FIELD,
    AGENT_GEO_ISP_PROVIDER_FIELD,
    AGENT_GEO_ISP_SUB_DIVISION_ISO_CODE_FIELD,
    AGENT_GEO_ISP_SUBDIVISION_FIELD,
} from './AgentConstants';
import { useMaxMind } from '../../../stores/EnvironmentStore';
import MapRow from '../../properties/rows/MapProperty';
import { usePropertyStyles } from '../../properties/Properties';

const geoProviderLabelText = i18n._(t`ISP`);
const geoASNLabelText = i18n._(t`ASN`);
const geoIsoCodeLabelText = i18n._(t`Country Code`);
const geoSubdivisionIsoCodeLabelText = i18n._(t`Subdivision Code`);
const geoCityLabelText = i18n._(t`City`);
const geoSubdivisionLabelText = i18n._(t`Subdivision`);
const geoCountryLabelText = i18n._(t`Country`);
const geoPostalLabelText = i18n._(t`Postal Code`);
const geoLatitudeLabelText = i18n._(t`Latitude`);
const geoLongitudeLabelText = i18n._(t`Longitude`);
const geoLocationLabelText = i18n._(t`Location`);

export default function AgentReadOnlyGeoISP({ agent, readOnlyTopMargin }) {
    const classes = usePropertyStyles();
    const [maxmind] = useMaxMind();
    if (_.isEmpty(agent)) {
        return null;
    }

    return (
        <>
            {maxmind && (
                <FormSection title={<Trans>GeoIP</Trans>}>
                    <Box mt={readOnlyTopMargin}>
                        <NgpLabelValue
                            dataLabel={geoProviderLabelText}
                            dataValue={_.get(agent, AGENT_GEO_ISP_PROVIDER_FIELD)}
                            showIfEmpty
                        />
                        <NgpLabelValue
                            dataLabel={geoASNLabelText}
                            dataValue={_.get(agent, AGENT_ASN_FIELD)}
                            showIfEmpty
                        />
                        <NgpLabelValue
                            dataLabel={geoIsoCodeLabelText}
                            dataValue={_.get(agent, AGENT_GEO_ISP_ISO_CODE_FIELD)}
                            showIfEmpty
                        />
                        <NgpLabelValue
                            dataLabel={geoSubdivisionIsoCodeLabelText}
                            dataValue={_.get(agent, AGENT_GEO_ISP_SUB_DIVISION_ISO_CODE_FIELD)}
                            showIfEmpty
                        />
                        <NgpLabelValue
                            dataLabel={geoCityLabelText}
                            dataValue={_.get(agent, AGENT_GEO_ISP_CITY_FIELD)}
                            showIfEmpty
                        />
                        <NgpLabelValue
                            dataLabel={geoSubdivisionLabelText}
                            dataValue={_.get(agent, AGENT_GEO_ISP_SUBDIVISION_FIELD)}
                            showIfEmpty
                        />
                        <NgpLabelValue
                            dataLabel={geoCountryLabelText}
                            dataValue={_.get(agent, AGENT_GEO_ISP_COUNTRY_FIELD)}
                            showIfEmpty
                        />
                        <NgpLabelValue
                            dataLabel={geoPostalLabelText}
                            dataValue={_.get(agent, AGENT_GEO_ISP_POSTAL_FIELD)}
                            showIfEmpty
                        />
                        <NgpLabelValue
                            dataLabel={geoLatitudeLabelText}
                            dataValue={_.get(agent, AGENT_GEO_ISP_LATITUDE_FIELD)}
                            showIfEmpty
                        />
                        <NgpLabelValue
                            dataLabel={geoLongitudeLabelText}
                            dataValue={_.get(agent, AGENT_GEO_ISP_LONGITUDE_FIELD)}
                            showIfEmpty
                        />
                        <NgpLabelValue
                            dataLabel={geoLocationLabelText}
                            dataValue={
                                !_.isEmpty(_.get(agent, AGENT_GEO_ISP_LATITUDE_FIELD)) &&
                                !_.isEmpty(_.get(agent, AGENT_GEO_ISP_LONGITUDE_FIELD)) ? (
                                    <MapRow
                                        classes={classes}
                                        row={{
                                            value: {
                                                latitude: _.get(agent, AGENT_GEO_ISP_LATITUDE_FIELD),
                                                longitude: _.get(agent, AGENT_GEO_ISP_LONGITUDE_FIELD),
                                            },
                                        }}
                                        isTable={false}
                                    />
                                ) : null
                            }
                        />
                    </Box>
                </FormSection>
            )}
        </>
    );
}
